import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { tempDynamicStoreconfig } from '../tempDynamicStoreconfig';
import { EncryptionService } from 'src/app/services/encryption.service';
import { AppEnum } from 'src/app/appenum';
import { AppNavigation } from 'src/app/services/app-navigation';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
import { LoggingService } from 'src/app/services/logging.service';

@Component({
  selector: 'app-validation-alert',
  templateUrl: './validation-alert.component.html',
  styleUrls: ['./validation-alert.component.scss'],
  standalone: false
})
export class ValidationAlertComponent implements OnInit {

  @Input() message: string = '';
  @Input() mandetoryCount: number = 0;
  @Input() isRequiredQuestionPending: boolean = false;
  @Input() zoneImageList: any[] = [];
  @Input() confirmText: string = 'Confirm';
  @Input() cancelText: string = 'Cancel';
  @Input() recomendedCount: number = 0;

  mandatoryZones: any[] = [];
  taskId: any;
  lat: any;
  long: any;
  componentName: string = 'validation-alert';

  get modalType(): 'mandatory' | 'recommended' | 'confirm' {
    if (this.mandetoryCount > 0 || this.isRequiredQuestionPending) return 'mandatory';
    if (this.recomendedCount > 0) return 'recommended';
    return 'confirm';
  }
  get isMandatory(): boolean {
    return this.mandetoryCount > 0 || this.isRequiredQuestionPending;
  }

  get confirmBtnText(): string {
    return this.isMandatory
      ? this._translateService.instant('common_text.ok_text')
      : this._translateService.instant('common_text.confirm_text');
  }

  constructor(
    private modalController: ModalController,
    private _translateService: TranslateService,
    public _nav: AppNavigation,
    private _tempDynamicFormConfig: tempDynamicStoreconfig,
    private encryptionService: EncryptionService,
    private _appenum: AppEnum,
    public loggingService: LoggingService
  ) {
    wrapAllMethodsWithLogging(this, this.componentName);
  }

  ngOnInit() {
    // Filter only mandatory zones
    this.taskId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.taskId))
    this.lat = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.latitude));
    this.long = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.longitude));
    this.mandatoryZones = this.zoneImageList.filter(
      z => z.validationState === 'mandatory'
    );

    // this.mandatoryZones = [{
    //   "zoneName": "BASE",
    //   "templateId": "DEYESTMP578"
    // }, {
    //   "zoneName": "BASE",
    //   "templateId": "DEYESTMP578"
    // },
    // {
    //   "zoneName": "BASE",
    //   "templateId": "DEYESTMP578"
    // }]
    console.log("mandatoryZones", this.mandatoryZones)
  }

  onZoneSectionScroll(event: Event) {
    event.stopPropagation();
  }

  navigateToZone(zone: any, index: any) {
    console.log("zone", zone)
    this.modalController.dismiss({ confirmed: false });
    const actualIndex = this._tempDynamicFormConfig.serverData?.findIndex(
      (s: any) => s.templateId === zone.zoneName?.templateId
    );
    console.log("actualIndex", actualIndex)

    this._nav.navigateRoot(['user-panel/tasks/start-inspection-form', {
      previousComponent: 'taskSummary',
      taskId: this.taskId,
      latitude: this.lat,
      longitude: this.long,
      TakenPhotStatus: false,
      templateId: zone.zoneName.templateId,
      navigateToChild: true,
      lastSlideIndex: actualIndex !== -1 ? actualIndex : 0,
    }]);
  }

  onConfirm() {
    if (this.isMandatory) {
      // just close, user must fix mandatory
      this.modalController.dismiss({ confirmed: false });
    } else {
      // proceed to submit
      this.modalController.dismiss({ confirmed: true });
    }
  }

  onFillNow() {
    // just close modal, user fills recommended fields
    this.modalController.dismiss({ action: 'fillNow' });
  }

  onSubmitWithout() {
    // submit ignoring recommended
    this.modalController.dismiss({ action: 'submit' });
  }

  onSubmit() {
    // confirm submit
    this.modalController.dismiss({ action: 'submit' });
  }

  dismiss() {
    this.modalController.dismiss({ action: 'dismiss' });
  }
}